<template>
  <div class="card" @click.stop.self="$emit('click')">
    <i @click.stop.self="$emit('click')" class="fas" :class="icon" />  
    <h4 @click.stop.self="$emit('click')">{{name}}</h4>
  </div>
</template>

<script>
  export default {
    props: ['name', 'icon'],
  }
</script>

<style lang="scss" scoped>
.card{
  padding: 5px 25px;
  margin-bottom: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.card:hover{
  background-color: #f0f0f0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>